import React from 'react';

const TopRunners = ({ topRunners }) => (
  <div className="top-runners">
    <h2>Top 10 Läufer</h2>
    <div className="runners-list">
      {topRunners.map((runner, index) => (
        <div key={runner.name} className="runner-item">
          <div className="rank">{index + 1}</div>
          <div className="runner-details">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span className="name">{runner.name}</span>
              {runner.milestones.length > 0 && (
                <div style={{ display: 'flex', gap: '4px' }}>
                  {runner.milestones.map(milestone => (
                    <span
                      key={milestone.km}
                      title={`${milestone.label}: ${milestone.km}km erreicht!`}
                      style={{ fontSize: '1.2rem', cursor: 'help' }}
                    >
                      {milestone.emoji}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <span className="kilometers">{runner.kilometers.toFixed(1)} km</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default TopRunners;
